import { IconProps } from "../../../types/style";

const EyeSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox='0 0 25 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='eye'>
          <path
            id='Vector'
            d='M16.08 12C16.08 13.98 14.48 15.58 12.5 15.58C10.52 15.58 8.92004 13.98 8.92004 12C8.92004 10.02 10.52 8.42004 12.5 8.42004C14.48 8.42004 16.08 10.02 16.08 12Z'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M12.5 20.27C16.03 20.27 19.32 18.19 21.61 14.59C22.51 13.18 22.51 10.81 21.61 9.39997C19.32 5.79997 16.03 3.71997 12.5 3.71997C8.96997 3.71997 5.67997 5.79997 3.38997 9.39997C2.48997 10.81 2.48997 13.18 3.38997 14.59C5.67997 18.19 8.96997 20.27 12.5 20.27Z'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </svg>
    </div>
  );
};

export default EyeSVG;
